const doc = [({"en":({"js":({"components":({"school_classes":({"upgrade_license_button":({"upgrade_license":"Upgrade license", "change_subscription":"Change subscription"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;